<div class="gradient" style="height: calc(100vh - 112px);">
  <ng-scrollbar>
    <div class="ot-tiles ot-section">
      <div class="ot-hero-tile ot-carousel">
        <div class="ot-carousel__caption ot-mr-6">
          <h1>
            Welcome, {{userAuthInfo.firstName == '' || userAuthInfo.lastName == '' ? userAuthInfo.userName :
            userAuthInfo.firstName}}
          </h1>
          <p>
            {{today | date:'EEEE, LLLL d, yyyy'}}
          </p>
        </div>
        @if (!isAgentChartDataLoaded) {
          <div class="ot-carousel__element ot-pl-6 ot-pr-6">
            <div class="ot-level" style="width: 120px;">
              <div class="ot-level__left">
                <div class="ot-level__item">
                </div>
              </div>
              <div class="ot-level__center">
                <div class="ot-level__item">
                  <div class="ot-progress-container">
                    <div id="ot-spinner-text" class="ot-progress ot-progress--is-spinner ot-progress--is-spinner-has-text">
                      <div class="ot-progress__outer">
                        <div class="ot-progress__meter">
                        </div>
                      </div>
                      <div class="ot-progress__text" style="color: #ffffff;" i18n>
                    Loading...
                  </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ot-level__right">
                <div class="ot-level__item">
                </div>
              </div>
            </div>
          </div>
        }
        @if (agentChartData.datasets[0].data.length > 0) {
          <div class="ot-carousel__element ot-pl-1">
            <canvas id="otsc-home-systems-chart" baseChart [data]="agentChartData" [options]="agentChartOptions" [type]="agentChartType">
            </canvas>
          </div>
        }
        @if (isAgentChartDataLoaded && agentChartData.datasets[0].data.length === 0) {
          <div class="ot-carousel__caption ot-pl-3 ot-pr-2">
            <span i18n id="otsc-home-systems-chart">
          There are no systems to display
        </span>
          </div>
        }
      </div>
      <app-list-tile [title]="notificationTitle" [id]="notificationId" [list]="notifications"
        [isLoading]="isNotificationsLoading" [viewLink]="notificationLink" [viewLinkDescription]="notificationLinkDesc">
        <ng-scrollbar>
          <ul class="ot-list">
            @for (notification of notifications; track notification) {
              <li tabindex="0" class="ot-row ot-notification-list-item">
                <div class="ot-notification-list-item-msg" (click)="handleNotificationLink(notification)" (keyup.enter)="handleNotificationLink(notification)">
                  <div class="ot-notification-list-item-col-icon">
                    <img class="ot-notification-list-item-icon" [src]="notification.icon" [alt]="notification.alt" i18n-alt />
                  </div>
                  <div class="ot-notification-list-item-col-details">
                    <div class="ot-notification-list-item-title">
                      <b i18n>{{notification.message}}</b>
                    </div>
                    <div class="ot-notification-list-item-detail">
                      {{notification.messageText}}
                    </div>
                  </div>
                  <div class="ot-notification-list-item-col-date">
                    <div class="ot-notification-list-item-date">
                      {{notification.timestamp | fromNow}}
                    </div>
                  </div>
                </div>
              </li>
            }
          </ul>
        </ng-scrollbar>
      </app-list-tile>
      <app-list-tile [title]="pendingSystemsTitle" [id]="pendingSystemsId" [titleType]="'complex'"
        [list]="pendingSystemsRows" [isLoading]="isPendingSystemsLoading" [viewLink]="pendingSystemsLink"
        [viewLinkDescription]="pendingSystemsLinkDesc">
        <div class="table-container">
          <app-datatable [cols]="pendingSystemsCols" [rows]="pendingSystemsRows" [identifier]="pendingSystemsTableId"
            (onclickrowlink)="pendingSystemsRowClicked($event)">
          </app-datatable>
        </div>
      </app-list-tile>
      <app-list-tile [title]="patchesAndUpdatesTitle" [id]="patchesAndUpdatesId" [titleType]="'detail'"
        [list]="patchesAndUpdatesRows" [isLoading]="isPatchesAndUpdatesLoading" [viewLink]="patchesAndUpdatesLink"
        [viewLinkDescription]="patchesAndUpdatesLinkDesc">
        <div class="table-container">
          <app-datatable [cols]="patchesAndUpdatesCols" [rows]="patchesAndUpdatesRows"
            [identifier]="patchesAndUpdatesTableId" (onclickrowlink)="patchesAndUpdatesRowClicked($event)">
          </app-datatable>
        </div>
      </app-list-tile>
      @for (item of shortcuts; track item; let i = $index) {
        @if (i % 2 === 0) {
          <div class="ot-subway-tiles ot-subway-tiles--has-double-tile">
            <a [id]="shortcuts[i].id" [ngClass]="shortcuts[i].class" class="ot-shortcut-tile"
              [routerLink]="[shortcuts[i].path]">
              <div class="ot-shortcut-tile__icon ot-shortcut-tile__icon__80">
                <img alt="" [src]="'assets/icons/' + shortcuts[i].icon">
              </div>
              <div class="ot-shortcut-tile__title">
                {{shortcuts[i].label}}
              </div>
            </a>
            <a [id]="shortcuts[i + 1].id" [ngClass]="shortcuts[i + 1].class" class="ot-shortcut-tile"
              [routerLink]="[shortcuts[i + 1].path]">
              <div class="ot-shortcut-tile__icon ot-shortcut-tile__icon__80">
                <img alt="" [src]="'assets/icons/' + shortcuts[i + 1].icon">
              </div>
              <div class="ot-shortcut-tile__title">
                {{shortcuts[i + 1].label}}
              </div>
            </a>
          </div>
        }
      }
    </div>
  </ng-scrollbar>
</div>